import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { LandingListComponent } from "./landing-list/landing-list.component";

const routes: Routes = [
  {
    path: "landings",
    component: LandingListComponent,
    canActivate: [AuthGuard],
  },
];

export const LandingsRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/landings.routes.ts